import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('ProfileScreen').create(({ theme }) => ({
  root: {
    display: 'flex',

    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    height: '100vh',

    width: '100%',

    color: theme.colors.text.primary,
    backgroundColor: theme.colors.background.primary,
    overflowX: 'hidden',
    overflowY: 'scroll',
  },

  backgroundContainer: {
    position: 'relative',
    width: '100%',
    minHeight: '220px',
    background: 'url(/assets/backgrounds/steamProfileBackground.webp)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },

  contentContainer: {
    display: 'flex',

    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    width: '100%',
    padding: '0 5%',
    gap: '12px',
    color: theme.colors.text.primary,
    backgroundColor: theme.colors.background.primary,
    paddingBottom: '150px',
  },

  status: {
    display: 'block',
    width: '100%',
    textAlign: 'center',
    position: 'absolute',
    margin: '0px',
    bottom: '5%',
    zIndex: 4,
    color: theme.colors.text.success,
    fontWeight: '450',
    fontSize: '13px',
    lineHeight: '18px',
  },

  tabList: {
    backgroundColor: '#B0B1B81F',
  },

  textsWrapper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },

  sectionHeadingText: {
    display: 'block',
    width: '100%',
    fontSize: '18px',
    fontWeight: 450,
    textAlign: 'left',
    lineHeight: theme.sizes.texts.lineHeight.m,
  },

  lastUpdateText: {
    display: 'block',
    width: '100%',
    fontSize: '13px',
    fontWeight: 350,
    textAlign: 'left',
    color: theme.colors.text.secondary,
    lineHeight: '15.6px',
  },

  name: {
    margin: '0',
    fontFamily: 'Inter',
    fontWeight: '550',
    fontSize: theme.sizes.texts.fontSize.l,
    lineHeight: theme.sizes.texts.lineHeight.xl,
  },
}))
